import { TenantDetalhe } from "core/features/tenants/typings/tenant";
import axios from "infra/http";
import { useQuery } from "react-query"; 

function useCliente(id?: string) {
  return useQuery(
    `/v1/clientes-tenant/${id}`,
    async () => {
      const res = await axios.get<TenantDetalhe>(`/v1/clientes-tenant/${id}`);

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useCliente;
